import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useVigilanteReloadContext } from "../../../../context/VisitantesVigilantesContext";
import CorrespondenciaVigilanteService from "../../../../services/CorrespondenciaVigilanteService";
import CorrespondenciaSalida from "./FormVigilante/CorrespondenciaSalida";
import { LinkPrimary } from "../components/CitoPlusLink";
import { InmuebleIcon } from "../components/Icons/InmuebleIcon";
import { ImageWithFallback } from "../components/ImageWithFallback";
import { SpinnerCitoPlus } from "../components/loadingLogo";
import ingreso_mensajeria from "../../../../images/vigilantes/ingreso_mensajeria_5_transparente.png";

const CorrespondenciaCard = ({ item, onAction }) => {
  return (
    <Card>
      <Card.Body>
        <h4 className="fs-20">{item.vigilante_nombre_ingreso}</h4>
        <div className="listline-wrapper mb-4">
          <span className="item">
            <InmuebleIcon />
            {item.inmueble && <span className="ms-1">{item.inmueble}</span>}
            <i className="fas fa-caret-right ms-2 me-2"></i>
            {item.created_at}
          </span>
        </div>
        <div className="d-sm-flex align-items-start pe-md-3 pe-0">
          <ImageWithFallback
            src={item.foto}
            alt=""
            className="img-thumbnail"
            style={{ objectFit: "cover", width: "80px", height: "80px" }}
          />
          <div className="ms-sm-3 mt-2 mt-sm-0">
            <span>{item.obj}</span>
          </div>
        </div>
      </Card.Body>
      <Card.Footer className="d-flex justify-content-between align-items-center flex-wrap">
        <div className="mb-2"></div>
        <div className="mb-2">
          <LinkPrimary
            href="#"
            className="position-relative"
            onClick={() => onAction(item.slug)}
          >
            <i className="fas fa-check me-2"></i>
            Marcar como Recogido
          </LinkPrimary>
        </div>
      </Card.Footer>
    </Card>
  );
};

export const Correspondencia = () => {
  const { reloadData, setReloadData } = useVigilanteReloadContext();
  const [pendientes, setPendientes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [showModalSalida, setShowModalSalida] = useState(false);
  const [uuidCorrespondencia, setUuidCorrespondencia] = useState(null);

  const fetchPendientes = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await CorrespondenciaVigilanteService.getPendientes();
      setPendientes(response.data);
    } catch (error) {
      console.error("Error fetching pendientes:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const filteredPendientes = useMemo(() => {
    const searchTerm = filterText.toLowerCase();
    return pendientes.filter(
      (p) =>
        p.obj?.toLowerCase().includes(searchTerm) ||
        p.inmueble?.toLowerCase().includes(searchTerm),
    );
  }, [pendientes, filterText]);

  const handleMarcarRecogido = useCallback((uuid) => {
    setUuidCorrespondencia(uuid);
    setShowModalSalida(true);
  }, []);

  useEffect(() => {
    fetchPendientes();
  }, [fetchPendientes]);

  useEffect(() => {
    if (reloadData.correspondencia) {
      fetchPendientes();
      setReloadData((prev) => ({ ...prev, correspondencia: false }));
    }
  }, [reloadData.correspondencia, fetchPendientes, setReloadData]);

  return (
    <>
      <section className="card">
        <header className="card-header">
          <div className="d-flex flex-wrap align-items-center gap-2 w-100">
            <div className="d-flex flex-column me-auto flex-grow-1">
              <h2 className="card-title mb-0">Correspondencia - Pendientes</h2>
              <div className="text-muted small">
                {isLoading
                  ? "Cargando..."
                  : `${filteredPendientes.length} correspondencia${
                      filteredPendientes.length !== 1 ? "s" : ""
                    } pendiente${filteredPendientes.length !== 1 ? "s" : ""}`}
              </div>
            </div>
          </div>
        </header>
        <div className="card-body">
          <div className="row g-3 mb-4">
            <div className="col-xl-4 col-lg-5 col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar en pendientes"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>
        </div>
      </section>

      {isLoading ? (
        <div className="py-5 text-center">
          <SpinnerCitoPlus text="Cargando correspondencia..." />
        </div>
      ) : filteredPendientes.length === 0 ? (
        <Col xl={12} className="text-center">
          <img
            src={ingreso_mensajeria}
            alt="No hay correspondencia pendiente"
            className="img-fluid"
          />
          <h3 className="mt-3">No hay correspondencia pendiente</h3>
        </Col>
      ) : (
        <Row>
          {filteredPendientes.map((item) => (
            <Col xl={6} key={item.slug}>
              <CorrespondenciaCard
                item={item}
                onAction={handleMarcarRecogido}
              />
            </Col>
          ))}
        </Row>
      )}

      <CorrespondenciaSalida
        uuidCorrespondencia={uuidCorrespondencia}
        showModal={showModalSalida}
        onClose={() => setShowModalSalida(false)}
      />
    </>
  );
};

export default Correspondencia;
